


<div class="containers">
    <h2 class="sub_title">Subscriptions</h2>
    <p class="sub_title_p">Manage your host subscriptions</p>
</div>

<div class="um-container" style="margin-bottom: 10px">
    <div class="ud-form-group">
        <label for="form-group--1" class=" ud-heading-sm">
            Active plans
        </label>
        <div class="edit-account-form--form-control-container--1NHES">
            <div class="edit-account-form--fake-input--1C1DY">
                <span></span>
                <p>You don't have any active subscriptions</p>
            </div>
        </div>
    </div>
</div>

<div class="um-container">
    <div class="ud-form-group">
        <label for="form-group--1" class="ud-heading-sm">
            Subscription plans available
        </label>

        <div class="container123">
            <div class="bordered-container">
                <div class="headers123">
                    <h2>Personal Plan</h2>
                    <div>
                        <p>Access to 10,500+ top courses</p>
                        <p>Courses in tech, business, and more</p>
                        <p>Practice tests, exercises, and Q&A</p>
                    </div>
                    <button class="btn btn-primary" style="margin-left:35px;margin-bottom :2px">Subscribe</button>

                </div>
                <div class="image">
                    <img [src]="profile_picture" alt="Image">
                </div>
            </div>

        </div>

    </div>
</div>

